import { Component } from 'react';
import { connect } from 'react-redux';

import { createEventReservation, getEvents, getPaymentTypes } from '../actions/EventReservationActions';

import { Button, Heading, Pane } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import EventReservationForm from '../components/EventReservationForm';

import Configuration from '../Config';

const validation = Configuration.Validations;
const defaultValues = Configuration.Defaults.createEventReservation;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class CreateEventReservation extends Component {

    componentDidMount() {
        // Only load payment types, events will be searched on demand
        this.props.dispatch(getPaymentTypes());
    }

    handleSave = (values) => {
        this.props.dispatch(createEventReservation(values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/event-reservations">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista rezervari
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Rezervare noua
                    </Heading>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <EventReservationForm
                            isEdit={false}
                            initialValues={defaultValues}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            events={this.props.events}
                            paymentTypes={this.props.paymentTypes}
                            errors={this.props.errors} />
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.eventReservations.errors.type === 'validation' ? mapValidationErrors(state.eventReservations.errors.fields) : [],
        events: state.eventReservations.events || [],
        paymentTypes: state.eventReservations.paymentTypes || []
    }
}

export default connect(mapStateToProps)(CreateEventReservation);
